export default __webpack_public_path__ + "static/media/Thief's Belt of the Smoldering Throne.3191cc7c.jpg";